import userx from '@/store/modules/userx';
import { FirebaseSocket } from './firestore';
import { SetSupportLvlResponse } from './models.def';

let auth: firebase.auth.Auth;
let db: firebase.firestore.Firestore;
let functions: firebase.functions.Functions;


export class GobiFirebaseSocket extends FirebaseSocket {

	public constructor() {
		super('none');
		auth = this.auth;
		db = this.db;
		functions = this.functions;
	}

	public async setSupportLvl(email: string, supportLvl: number): Promise<SetSupportLvlResponse> {
		const user = userx.user;
		if (!user) { return { success: false, email, supportLvl, errorMessage: 'No user' }; }

		const adminLvl = 10;
		const defaultAdminEmail = ['dragonwhites@gmail.com', 'master@gobi.my'];
		let authorized = false;

		// check request is made by an admin lvl support
		if (user.supportLvl && user.supportLvl >= adminLvl || defaultAdminEmail.includes(user.email)) { authorized = true; }
		if (!user.emailVerified) { authorized = false; }

		if (!authorized) {
			return {
				success: false, email, supportLvl,
				errorMessage: `Only level ${adminLvl} support with verified email can perform this action`,
			};
		}
		try {

			const haveUser = await this.isUserExist(email);
			if (!haveUser) {
				return {
					success: false, email, supportLvl,
					errorMessage: 'User does not exist.',
				};
			}
			await functions.httpsCallable('setSupportLvl')({ email, supportLvl });
			return { success: true, email, supportLvl } as SetSupportLvlResponse;
		} catch (error: any) {
			console.error(error);
			return {
				success: false,
				email,
				supportLvl,
				error,
				errorCode: error.detail || error.code,
				errorMessage: error.message,
			};
		}
	}

	public assertSupportLvl(requiredLvl: number) {
		const user = userx.user;
		if (!user) {
			return { success: false, errorCode: 'unauthenticated', errorMessage: 'No user' };
		}
		if (!user.emailVerified) {
			return { success: false, errorCode: 'unverified-email', errorMessage: 'Email not verified' };
		}
		if (user.supportLvl == null || user.supportLvl < requiredLvl) {
			return {
				success: false, errorCode: 'insufficient-support-level',
				errorMessage: `Only level ${requiredLvl} support or above can perform this action`,
			};
		}
		return { success: true };
	}

	protected _readExtraDocs(userObject: any) {
		const { email, displayName, emailVerified, uid } = this;
		const user = auth.currentUser!;

		// get user supportLvl
		user.getIdTokenResult().then((idTokenResult: firebase.auth.IdTokenResult) => {
			userObject.supportLvl = idTokenResult.claims.supportLvl || 0;
			userx.updateUser(userObject);
		});
	}
}


const fb = new GobiFirebaseSocket();
export default fb;
